import React, { useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { getApi } from '../services/ApiService';

type HelloResponse = { message: string; user?: string };

export default function ApiTest() {
  const [result, setResult] = useState<HelloResponse | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const testApi = async () => {
    setLoading(true); setError(''); setResult(null);
    try { setResult(await getApi<HelloResponse>('hello')); }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'The API request failed.'); }
    finally { setLoading(false); }
  };
  return (
    <div className="section-panel">
      <h1>API Test</h1>
      <p>Call the authenticated .NET API to confirm front-end/back-end communication.</p>
      <Button onClick={testApi} disabled={loading}>{loading ? 'Calling API...' : 'Call Hello World API'}</Button>
      {result && <pre className="api-result mt-3" aria-live="polite">{JSON.stringify(result, null, 2)}</pre>}
      {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
    </div>
  );
}
